import React from 'react';
import PropTypes from 'prop-types';

export default function StairsIconUp({ scaleFactor = 1 }) {
return (
    <svg
      width={32 * scaleFactor}
      height={32 * scaleFactor}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
          <path d="M25 7V1H31V31H1V27V25H5H7V19H13V13H19V7H25Z" fill="#84888A" />
          <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.3027 5L11.2469 5L11.3027 5C11.4369 5 11.5587 5.05871 11.6484 5.15428C11.744 5.24408
            11.8027 5.36587 11.8027 5.5L11.8027 5.55586L11.8027 6.5L11.8027 12.4441C11.8027 12.7511 11.5789
            13 11.3027 13L10.3027 13C10.0266 13 9.80273 12.7511 9.80273 12.4441L9.80273 8.31354L2.52747 15.5888C2.34723
            15.7691 2.04459 15.7551 1.85152 15.5577L1.15233 14.8428C0.959254 14.6453 0.94885 14.3392 1.12909 14.1589L8.28803
            7L4.3586 7C4.0516 7 3.80274 6.77614 3.80274 6.5L3.80273 5.5C3.80273 5.22386 4.0516 5 4.3586 5L10.3027 5Z"
              fill="#84888A"
          />
    </svg>
);
}

StairsIconUp.propTypes = {
 scaleFactor: PropTypes.number,
};
